<template>
    <div>
        <div class="text-h5 text-center font-weight-bold mt-15 mb-4">
            {{$t('eshop::also-like.you_would_also_like')}}
        </div>
        <div class="d-flex product-swiper align-center mt-5 mb-10 position-relative">
            <div class="swiper-button-prev mr-4" id="swiper-prev-also-like"></div>
            <swiper
                :modules="[Navigation]"
                class="d-flex align-center align-self-stretch"
                :space-between="10"
                :breakpoints="breakpoints"
                :touch-start-prevent-default="false"
                :navigation="{
                                nextEl: '#swiper-next-also-like',
                                prevEl: '#swiper-prev-also-like',
                            }"
            >
                <swiper-slide v-for="product in $page.props.also_like" :key="product.id">
                    <div class="pa-4">
                        <base-product :product="product" :css-class="['h-100']" />
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-next ml-4" id="swiper-next-also-like"></div>
        </div>
    </div>
</template>

<script setup>
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import BaseProduct from "./BaseProduct.vue";
import {useDisplay} from "vuetify";
import {markRaw} from "vue";
const {thresholds} = useDisplay();

const breakpoints = markRaw({
    [thresholds.value.lg]: {
        slidesPerView: 4
    },
    [thresholds.value.md]: {
        slidesPerView: 3
    },
    [thresholds.value.sm]: {
        slidesPerView: 2
    },
    [thresholds.value.xs]: {
        slidesPerView: 1
    },
});

</script>

<style scoped>

</style>
